var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menus"},_vm._l((_vm.menus),function(item){return _c('li',[_c('a',{attrs:{"href":`#${item.id}`}},[_vm._v("#"+_vm._s(item.title))]),(item[_vm.childLabel])?_c('ul',{staticClass:"child"},[_c('menu-tree',{attrs:{"menus":item[_vm.childLabel],"child-label":_vm.childLabel}})],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }